
export class AttackButton {
  private readonly element: HTMLButtonElement;
  private pressed = false;

  constructor(container: HTMLElement) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "attack-button";
    button.textContent = "attack";
    button.hidden = true;
    // The label is decoration; the accessible name is the control.
    button.setAttribute("aria-label", "Attack");

    // Pointer events, not click: the button auto-repeats while held, so what
    // matters is the press and the release, not the completed gesture.
    button.addEventListener("pointerdown", (event) => {
      event.preventDefault();
      this.pressed = true;
    });
    const release = (): void => {
      this.pressed = false;
    };
    button.addEventListener("pointerup", release);
    button.addEventListener("pointercancel", release);
    // A pointer dragged off the button is a release: without this the button
    // stays latched and the player attacks forever.
    button.addEventListener("pointerleave", release);
    button.addEventListener("contextmenu", (event) => event.preventDefault());

    container.append(button);
    this.element = button;
  }

  get held(): boolean {
    return this.pressed;
  }

  reveal(): void {
    this.element.hidden = false;
  }

  setReadiness(readiness: number): void {
    this.element.style.opacity = readiness >= 1 ? "1" : `${(0.4 + 0.6 * readiness).toFixed(2)}`;
  }
}
